import React from 'react';
import { Box } from '@mui/material';
import ButtonApp from './DashboardButton';
import ArrowIcon from '/src/assets/images/button/arrow-down.svg?url';

// These report application state and do nothing when clicked, so they render
// as static badges rather than buttons.
//
// Two independent axes are shown side by side, so each label names the axis
// it belongs to. "فعال" next to "غیرفعال" read as a contradiction because one
// described the review outcome and the other the publisher's own switch.
export const ButtonAppActive: React.FC = () => (
  <ButtonApp
    badge
    label="تایید شده"
    width={62}
    height={24}
    backgroundColor="#DBFFF0"
    textColor="#139961"
    borderRadius={5}
  />
);

export const ButtonAppPublished: React.FC = () => (
  <ButtonApp
    badge
    label="منتشر شده"
    width={68}
    height={24}
    backgroundColor="#E3EAFF"
    textColor="#0525f2"
    borderRadius={5}
  />
);

/**
 * Counterpart to ButtonAppPublished: the store is not serving this listing.
 * Driven by the api's `status`, i.e. the `published` accessor — which needs an
 * approved build, an approved publisher and the switch on all at once — so it
 * can be false while "فعال" and "تایید شده" are both true. Muted rather than
 * red: not being live is a state, not an error.
 */
export const ButtonAppUnpublished: React.FC = () => (
  <ButtonApp
    badge
    label="منتشر نشده"
    width={72}
    height={24}
    backgroundColor="#EEF0F4"
    textColor="#60646E"
    borderRadius={5}
  />
);

export const ButtonAppPending: React.FC = () => (
  <ButtonApp
    badge
    label="درحال بررسی"
    width={72}
    height={24}
    backgroundColor="#FFE3D3"
    textColor="#FF833D"
    borderRadius={5}
  />
);

export const ButtonAppDeactive: React.FC = () => (
  <ButtonApp
    badge
    label="غیرفعال شده"
    width={80}
    height={24}
    backgroundColor="#A6AAB5"
    textColor="#FFFFFF"
    borderRadius={5}
  />
);

export const ButtonAppReject: React.FC = () => (
  <ButtonApp
    badge
    label="ردشده"
    width={52}
    height={24}
    backgroundColor="#FFD6DB"
    textColor="#EF4056"
    borderRadius={5}
  />
);

/**
 * The publisher's own on/off switch, the counterpart to ButtonAppDeactive.
 * Kept distinct from ButtonAppActive, which reports the review outcome.
 */
export const ButtonAppEnabled: React.FC = () => (
  <ButtonApp
    badge
    label="فعال"
    width={41}
    height={24}
    backgroundColor="#E8F5E9"
    textColor="#2E7D32"
    borderRadius={5}
  />
);

/**
 * Entry link shown at the bottom of an application card: label with the
 * chevron in its own outlined square, matching the design.
 */
export const ButtonAppInter: React.FC = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      // The card is RTL, so row-reverse puts the chevron box on the far left
      // with the label to its right, as in the design.
      flexDirection: 'row-reverse',
      gap: '10px',
      cursor: 'pointer',
      color: '#A6AAB5',
      fontFamily: 'IRANYekanXFaNum',
      fontWeight: 500,
      fontSize: 12,
      whiteSpace: 'nowrap',
      '&:hover .chevron-box': {
        borderColor: '#A6AAB5',
        backgroundColor: '#FAFAFB',
      },
    }}
  >
    <Box
      className="chevron-box"
      sx={{
        width: 34,
        height: 34,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #E5E5E8',
        borderRadius: '8px',
        transition: 'border-color .2s ease, background-color .2s ease',
      }}
    >
      <img
        src={ArrowIcon}
        alt=""
        aria-hidden="true"
        style={{ width: 18, height: 18 }}
      />
    </Box>
    ورود به صفحه اپلیکیشن
  </Box>
);
